export default function isValidHttpUrl(urlOrNotUrl: string) {
  let url: URL;

  try {
    url = new URL(urlOrNotUrl);
  } catch (_) {
    return false;
  }

  return url.protocol === 'http:' || url.protocol === 'https:';
}
